import React from "react";
import loadable from "@loadable/component";
const OrderListComponent = loadable(
  () => import("../../components/Order/OrderList")
);

export const OrderList = () => {
  return (
    <>
      <OrderListComponent />
    </>
  );
};
